import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

export enum ResultatAnnuler {
  Oui,
  Non
}

@Component({
  selector: 'app-dialog-annuler-modification',
  templateUrl: './dialog-annuler-modification.component.html',
  styleUrls: ['./dialog-annuler-modification.component.scss'],
  standalone: false
})
export class DialogAnnulerModificationComponent {
  constructor(public dialogRef: MatDialogRef<DialogAnnulerModificationComponent>) {}

  confirm() {
    this.dialogRef.close(ResultatAnnuler.Oui);
  }

  close() {
    this.dialogRef.close();
  }
}
